import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthStatusService } from '../../services/auth-status.service';
import * as env from '../../../environments/environment';

@Injectable()
export class CanActivateLogIn implements CanActivate {

    constructor(private authService: AuthStatusService, private router: Router, public jwtHelper: JwtHelperService) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const res: boolean = await this.authService.isAuthenticated();
        if (!res) {
            this.authService.redirectUrl = state.url;
            this.router.navigate(['/push/login']);
            return false;
        }

        let user = sessionStorage.getItem('currentUser');
        if(user) {
            let parsedUser = JSON.parse(user);
            if (parsedUser && parsedUser.id) {
                if (navigator.serviceWorker) {
                    navigator.serviceWorker.ready.then((registration) => {
                        registration.active?.postMessage({
                            type: 'SET_USER_ID',
                            userId: parsedUser.id
                        });
                        registration.active?.postMessage({
                            type: 'SET_API_URL',
                            apiUrl: env.environment.url
                        });
                    });
                }
            }
        }
        return res;
    }
}
